export default {
  path: '/wecode/:type/licenseInfo',
  auth: true,
  preload: false,
  key: 'Roma',
  layout: 'inner', // outer 一级菜单 inner 二级菜单
  component: (props) => import('./index')
};
